// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";

function getPayload(param) {
  return {
          core_pricing_external_id: param.core_pricing_external_id,
          modifications_tentative_statuses: List.map((function (m) {
                  var match = m.status;
                  var tmp;
                  switch (match) {
                    case /* Deactivate */0 :
                        tmp = "deactivated";
                        break;
                    case /* Delete */1 :
                        tmp = "deleted";
                        break;
                    case /* Approve */2 :
                        tmp = "approved";
                        break;
                    case /* Discard */3 :
                        tmp = "rejected";
                        break;
                    
                  }
                  return {
                          external_id: m.external_id,
                          tentative_status: tmp
                        };
                }), param.updated_modifications),
          prioritized_modification_ids: param.prioritized_modification_ids
        };
}

export {
  getPayload ,
  
}
/* No side effect */
